import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './outline-column.global.pcss?inline';

type colSpanRange = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type rowSpanRange = 1 | 2 | 3 | 4 | 5 | 6;
type VerticalAlignment = 'top' | 'middle' | 'bottom';

/**
 * The Outline Column component
 * @element outline-column
 *
 * @slot - The default slot for this element.
 */
@customElement('outline-column')
export class OutlineColumn extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });
  /**
   * The number of columns wide this column should be.
   */
  @property({ type: Number, reflect: true, attribute: 'col-span-default' })
  colSpanDefault: colSpanRange = 12;

  /**
   * The number of columns wide this column should be on small+ containers.
   */
  @property({ type: Number, reflect: true, attribute: 'col-span-sm' })
  colSpanSm: colSpanRange;

  /**
   * The number of columns wide this column should be on medium+ containers.
   */
  @property({ type: Number, reflect: true, attribute: 'col-span-md' })
  colSpanMd: colSpanRange;

  /**
   * The number of columns wide this column should be on large+ containers.
   */
  @property({ type: Number, reflect: true, attribute: 'col-span-lg' })
  colSpanLg: colSpanRange;

  /**
   * The number of columns wide this column should be on extra large+ containers.
   */
  @property({ type: Number, reflect: true, attribute: 'col-span-xl' })
  colSpanXl: colSpanRange;

  /**
   * The number of columns wide this column should be on extra extra large+ containers.
   */
  @property({ type: Number, reflect: true, attribute: 'col-span-2xl' })
  colSpan2xl: colSpanRange;

  /**
   * The number of rows this column will span.
   */
  @property({ type: Number, reflect: true, attribute: 'row-span' })
  rowSpan: rowSpanRange = 1;
  /**
   * The vertical placement of content inside of the column.
   */
  @property({ type: String, reflect: true, attribute: 'content-align' })
  contentAlign: VerticalAlignment = 'top';

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}
